import RestApiModel from "@/api/Model/RestApiModel";
import { fisgApi } from '@/api';

class Impersonate extends RestApiModel {
  static updateImpersonate(isImpersonation, impersonatedCompany) {
    return fisgApi.get('/UpdateImpersonate', {
      params: {
        IsImpersonation: isImpersonation,
        ImpersonatedCompany: impersonatedCompany,
      }
    });
  }

  static getImpersonate() {
    return fisgApi.get('/GetImpersonate');
  }

  static getCompanyList(excludeCurrent = true) {
    return fisgApi.get('/GetCompanyList', {
      params: {
        ExcludeCurrent: excludeCurrent,
      }
    });
  }
}

export default Impersonate;
